$(document).ready(function() {
    //   !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();


 const scrollEventTrigger = (cName) => {
        cName.addEventListener('wheel', (event) => {
            event.preventDefault();
            const delta = Math.sign(event.deltaY);
            cName.scrollBy({
                top: delta * window.innerHeight,
                behavior: 'smooth'
            });
        });
    }

    if (document.querySelector('#landing')) {
        const containerHomeLayout = document.querySelector('#landing');
      //  scrollEventTrigger(containerHomeLayout)
    }



  
    //Announcement bar close
    $('.announcement-bar-close').click(function (e) {
        e.preventDefault();
        $(this).parents('#shopify-section-announcement-bar').remove();
        $('.header-wrapper').css('top', '0')
    })

    let bar = $('.announcement-bar')
    if (bar.length == 0) {
        $('.header-wrapper').css('top', '0')
    }

    // Header fix
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('.header').addClass('bg-added');
        } else {
            $('.header').removeClass('bg-added');
        }
    });


    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    items.forEach(item => {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("ul").addEventListener("mouseleave", () => {
                item.removeAttribute("open");
            });
            item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
            });
        });

    });

    // $('.product-recommendations ul').slick({
    //     slidesToShow:2,
    //     dots:true,
    //     arrows:true,
    //     slidesToScroll:1
    // })
    var productRecommendations = setInterval(function () {
        if ($(".product-recommendations ul").length) {
            clearInterval(productRecommendations);
        }
        // slick slider code
        $(".product-recommendations ul").slick({
            dots: !0,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [{
                breakpoint: 1024,
                settings: 'unslick'
                // settings: {
                //     slidesToShow: 4,
                //     slidesToScroll: 1,
                //     dots: !1,
                //     arrows:false,
                // }
            }
                // ,
                //     {
                //         breakpoint: 480,
                //         settings:'unslick'
                //     }
            ]
        })
    }, 200);


    $('.headings-container.tabs h2').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('.tabs h2').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    })


    // var found = setInterval(function(){
    //     if( $(".slider-mobile-gutter .product__media-list").length ){
    //         clearInterval(found);
    //     }
    // }, 200);
    // slick slider code
    // $(".product__media-list").slick({
    //     dots: !1,
    //     arrows:true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     responsive: [{
    //         breakpoint: 1024,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             dots: !1,
    //             arrows:true,
    //         }
    //     },
    //         {
    //             breakpoint: 480,
    //             settings:'unslick'
    //         }
    //     ]
    // })

    $(".static-images").slick({
        dots: !0,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 1024,
            settings: 'unslick'
            /* settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 dots: !1,
                 arrows:false,
             }*/
        },
            {
                breakpoint: 480,
                settings: 'unslick'
            }
        ]
    })

    $(".other-services-item").slick({
        dots: !1,
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: true,
        responsive: [{
            breakpoint: 1024,
            settings: 'unslick'
        },
            {
                breakpoint: 480,
                settings: 'unslick'
            }
        ]
    });


    // Accourdian
    // Delete that line if you don't want the first Div to be displayed by default
    $("div.product-accordian:first").css("display", "none");
    //
    $(".product-accordian h3").click(function () {
        $(this).siblings().removeClass('active');
        $(this).toggleClass('active').next().css({'border-bottom': '1px solid #fff'}).slideToggle(500);
        $(".product-accordian div").not($(this).next().removeClass('active')).slideUp(500);

    });

    /*var found = setInterval(function(){
        if( $("body.mobile").length > 0){
            $('.career .text-with-img .career-content:first-of-type').css("display", "none");
            $('.career .text-content h3').click(function(){
                //$(this).siblings().removeClass('active');
                $(this).toggleClass('active').next().slideToggle(500);
                $(".career .text-content div.career-content").not($(this).next().removeClass('active')).slideUp(500);
            })
            clearInterval(found);
        }
    }, 200);*/

    var selectedColorVal = $('.pdp-section .product-form__input input[checked]').attr('value');
    $('.pdp-section .selected-color').text(selectedColorVal);
    $('.pdp-section .product-form__input input').click(function () {
        var selectedColor = $(this).attr('value');
        $('.pdp-section .selected-color').text('');
        $('.pdp-section .selected-color').text(selectedColor);
    })

    $('.pdp-section.pdp-add-to-cart variant-radios .product-form__input').each(function () {
        $('.pdp-section.pdp-add-to-cart .Size .selected-colors').text($('.Size input:checked').attr('value'));
        $('.pdp-section.pdp-add-to-cart .Colour .selected-colors').text($('.Colour input:checked').attr('value'));

        $('.pdp-section.pdp-add-to-cart .product-form__input.Size input').click(function () {
            let selectedColor = $(this).attr('value');
            $(this).parent().find('.selected-colors').text(selectedColor)

        })

        $('.pdp-section.pdp-add-to-cart .product-form__input.Colour input').click(function () {
            let selectedColor = $(this).attr('value');
            $(this).parent().find('.selected-colors').text(selectedColor)

        })

    })

    if ($('.breadcrumbs__list').length > 0) {
        var linkName = window.location.pathname;
        var separatedLinks = linkName.split('/');
        var lastLink = separatedLinks[2].replace('-', ' ');


        if ($('.breadcrumbs__list:visible')) {
            if ($('.breadcrumbs__list .test11.last').length > 1) {
                $('.breadcrumbs__list .test11.last:last-child').remove();
            }
            $('.breadcrumbs__list .test11.last a').text(lastLink)
        }
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.footer-block__heading').click(function () {
            $(this).next().slideToggle(500);
            $(this).toggleClass('active');
            that = $(this);
        })
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('body').addClass('mobile');
    }

    var bannerHeading = $('.banner__heading span').text();
    var splitted = bannerHeading.split('!');

    //if(!$('body').hasClass('mobile')){
    var scrollableHeading = $('.scrollable-heading').text();
    var repeatedText = scrollableHeading.repeat(3);
    $('.scrollable-heading').text(repeatedText);
    // }


    var breadcrumbLength = $('.breadcrumbs__list li').length;

    if (breadcrumbLength == 2) {
        var lastChild = $('.breadcrumbs__list li:last-child');
        var replacedText = $(lastChild).text().replace("/", "");
        $(lastChild).text(replacedText)

    }


    window.addEventListener("klaviyoForms", function (e) {
        if (e.detail.type == 'open') {
            setTimeout(function () {
                if ($('body').hasClass('mobile') === true) {
                    $('body div[role="dialog"] form.klaviyo-form').prepend('<div class="for-mobile"></div>');
                }
                $('body div[role="dialog"] form.klaviyo-form > div:nth-child(2)').append('<div class="klaviyo-social"><span class="klaviyo-instagram"><a href="https://www.instagram.com/freshtees.syd/"></a></span><span class="klaviyo-facebook"><a href="https://www.facebook.com/FreshTees.syd/"></a></span></div>');
            }, 500);
        }
        if (e.detail.type == 'submit') {
            //ga('send', 'event', 'Klaviyo form', 'form_submit', e.detail.formId);
            $('div[role="dialog"] form.klaviyo-form').addClass('klaviyo-submitted');
            setTimeout(function () {
                $('body div[role="dialog"] form.klaviyo-form > div:nth-child(2)').append('<div class="klaviyo-social"><span class="klaviyo-instagram"><a href="https://www.instagram.com/freshtees.syd/"></a></span><span class="klaviyo-facebook"><a href="https://www.facebook.com/FreshTees.syd/"></a></span></div>');
            }, 500);
        }
    });

    $('.header__icon--account[href="#"]').click(function () {
        $('.user-profile').toggle();
    })

    var found = setInterval(function () {
        if ($('.elfsight-sapp-55cb00af-9c5f-44f8-b046-55d92107b795').children().length > 0) {
            $('.elfsight-sapp-55cb00af-9c5f-44f8-b046-55d92107b795 .ttt').remove();
            clearInterval(found);
        }

        if ($('form[action="/cart/add"] #EFOLI_CUSTOMIZE_IT_BUTTON').length > 0) {
            // $('form[action="/cart/add"]').css('opacity', 0)
            var customizeForm = $('form[action="/cart/add"]');
            $('.pdp-buttons-container').append(customizeForm);
            $('form[action="/cart/add"]').css('opacity', 1);
            var btnWidth = $('.pdp-buttons-container>a').width()
            $('form[action="/cart/add"] #EFOLI_CUSTOMIZE_IT_BUTTON').css({
                'padding': '10px 20px 10px 20px',
                'font-size': '14px',
                'width': btnWidth
            })
            clearInterval(found);
        }
    }, 200)


    if (window.location.search == '?orders') {
        $('h2[data-tab="tab-2"] a').css('color', '#24272a');
        $('h2[data-tab="tab-2"]').trigger("click");

    }

    //hide it when clicking anywhere else except the popup and the trigger
    $(document).on('click touch', function (event) {
        if (!$(event.target).parents().addBack().is('.header__icon--account[href="#"]')) {
            $('.user-profile').hide();
        }
    });

    // Stop propagation to prevent hiding "#tooltip" when clicking on it
    $('.user-profile').on('click touch', function (event) {
        event.stopPropagation();
    });

    $('.view-all-addresses').click(function () {
        $('.tab-link[data-tab="tab-3"]').trigger("click");
    })

    var addr = $('.default-address-container p:first-child').text();


    // let breadcrumbList = $('.breadcrumbs .breadcrumbs__list').length;
    // console.log(breadcrumbList);
    if ($('.breadcrumbs').length > 0) {

        if ($('.breadcrumbs__list > li').length === 1) {
            $('.breadcrumbs__list').hide();
        }
    }

    if (window.location.pathname === '/pages/contact') {
        if (window.location.hash == '' && window.location.search == '?contact_posted=true') {
            $('.contact-form .contact-success').css({'display': 'block', 'color': 'green'});
            window.setTimeout(function () {
                location.replace("/pages/contact");
                //  window.location.reload();
            }, 3000);
        }
    }


    $('.acc-head').click(function () {
        $(this).next().slideToggle(500);
        $(this).toggleClass('active');
        $(this).parent().parent().toggleClass('activeTab');
    })
    $('.copy-text').on('click', function () {
        var copyText = document.querySelector("span[data-href]");
        var copyText2 = this.getAttribute('data-href');
        navigator.clipboard.writeText(copyText2);
    })
    $('#address_form_new #AddressCountryNew option:first-child').val('');
    $('.copy-text').click(function () {
        $('.link-copied').fadeIn();
        $('.link-copied').fadeOut(1000);
    })

    function squareImages() {
        $('.static-images img').each(function () {
            $(this).height($(this).width())
        })
        $('.design-lab-collection-section .image-with-text__media img').height($('.design-lab-collection-section .image-with-text__media img').width())
    }

    squareImages()

    $(window).resize(function () {
        squareImages()
    });


    // PDP steps container show based on customize button
    if ($('body').hasClass('product-page') == true) {

        let findCustomizeBtn = setInterval(function () {
            $('.pdp-section').removeClass('btn-found');
            if ($('#EFOLI_CUSTOMIZE_IT_BUTTON').length > 0) {
                $('.pdp-section').addClass('btn-found');
                $('.pdp-section .steps-container').css('display', 'flex');
                clearInterval(findCustomizeBtn);
            }
        }, 200)

    }
    if ($('nav.header__inline-menu').length) {
        $('nav.header__inline-menu > ul.list-menu > li').each(function (i) {
            var listWidth = $(this).find('header-menu .mega-menu .header__menu-item span a').width();
            if ($(this).find('summary').length > 0) {
                var leftPos = $(this).find('summary').offset().left + 12 + $(this).find('summary').width() / 2;
            } else {
                var leftPos = $(this).find('>a').offset().left + 12 + $(this).find('>a').width() / 2;
            }

            //  $(this).find('.mega-menu__content ul').css({'position':'absolute','padding':'15px','top':'10%',  'left':leftPos+halfOfTheWidth});
            //  $(this).find('.mega-menu__content ul').css({'position':'absolute','padding':'15px 0px 15px 0px','top':'10%',  'left':leftPos, 'transform':`translateX(-50%)`});
            //$(this).find('.mega-menu__content ul').css({'position':'absolute','padding':'15px','top':'10%',  'left':'50%', 'transform':'translateX(-50%)'})
        })
    }

    var btnFound = setInterval(function () {
        if ($('#EFOLI_CUSTOMIZE_IT_BUTTON').length > 0) {
            var pdpBtn = $('#EFOLI_CUSTOMIZE_IT_BUTTON');
            $('.pdp-buttons-container').append(pdpBtn);
            clearInterval(btnFound);
        }
    }, 200)

    $('.marquee_text').marquee({
        direction: 'left',
        duration: 70000,
        gap: 50,
        delayBeforeStart: 1000,
        duplicated: true,
        startVisible: true
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.marquee_text-mob').marquee({
            direction: 'left',
            duration: 20000,
            gap: 50,
            delayBeforeStart: 1000,
            duplicated: true,
            startVisible: true
        });
    }
    $(".static-pages-video-container").append($(".static-pages-video"));


    // Get Quote hover for Desktop
    $('.header-get-quote').hover(function () {
            // Mouse enter event
            $(this).addClass('open-links');
        },
        function () {
            $(this).removeClass('open-links');
        })

    $('.header-get-quote').click(function () {
        $('.header-get-quote-links').toggle();
    })

    $(document).on('click touch', function (event) {
        if (!$(event.target).parents().addBack().is('.header-get-quote, .header__menu-item')) {
            $('.header-get-quote-links').hide();
        }
    });


    // Expand Services and Industries Images when Hover


    $('.home-services .multicolumn-list li, .home-industries .multicolumn-list li').each(function () {
        $(this).hover(
            function () {
                $('.home-services .multicolumn-list li, .home-industries .multicolumn-list li').removeClass('hovered');
                $(this).addClass('hovered');
            },
            function () {
                $('.home-services .multicolumn-list li, .home-industries .multicolumn-list li').removeClass('hovered');
                $('.home-services .multicolumn-list li:first-child, .home-industries .multicolumn-list li:first-child').addClass('hovered');
            }
        );
    })


    // Static Images Slider (Our works and A few of our events)

    $('.static-images-container').slick({
        dots: true,
        arrows: true,
        slidesToShow: 1.35,
        infinite:false,
        slidesToScroll: 1,
        mobileFirst: true,
        // centerMode: true,
        dotsClass: 'custom_paging',
        customPaging: function (slider, i) {
            //FYI just have a look at the object to find aviable information
            //press f12 to access the console
            //you could also debug or look in the source
            return (i + 1) + '/' + slider.slideCount;
        },
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false,
                dotsClass: 'slick-dots',
                customPaging: function (slider, i) {
                    //FYI just have a look at the object to find aviable information
                    //press f12 to access the console
                    //you could also debug or look in the source
                    return '';
                },
            }
        },
            {
                breakpoint: 480,
            }
        ]
    })


    $('.static-images-container').css('display', 'block');


    // Live events landing news slider

    $('.live-events-landing .blog-posts-container .blog__posts').slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 1.03,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: false,
        adaptiveHeight: true,
        dotsClass: 'custom_paging',
        customPaging: function (slider, i) {

            return (i + 1) + '/' + slider.slideCount;
        },
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4.5,
                dots: true,
                infinite: false,
                arrows: true,
                centerMode: false,
                dotsClass: 'slick-dots',
                customPaging: function (slider, i) {
                    return '';
                },
            }
        },
            {
                breakpoint: 480,
            }
        ]
    })

  

    $('.live-events-landing section .blog-posts-container').css('opacity', 1);




    /*
    $('.active-collection.collection-list').slick({
            dots: false,
            arrows:false,
            infinite:false,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode:false,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4.5,
                    dots:true,
                    infinite: false,
                    arrows:true,
                    centerMode:false,
                }
            },
                {
                    breakpoint: 480,
                }
            ]
        })
*/


    // Studio - Fresh  custom collection list slider

    $('.collection-products-only-list').slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: false,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                dots: true,
                infinite: false,
                arrows: true,
                centerMode: false,
            }
        },
            {
                breakpoint: 480,
            }
        ]
    })

    $('.collection-products-only-list').slick('refresh');

    $('.collection-products-only-list').css('display', 'block');

    $('ul.main-menu > li').each(function () {
        if ($(this).find('.main-submenu>li ul.sub-submenu').length == 0) {
            // $(this).find('.main-submenu').css('border','1px solid #f00');
            $(this).find('.main-submenu').addClass('noChilds');
        }
    });

    // Single Scroll snap snippet

    const container = document.querySelector('.home-sections');
    if (container) {
        container.addEventListener('scroll', () => {
            const scrollPosition = container.scrollTop;
            console.log('Scroll position:', scrollPosition);
            if (scrollPosition > 1) {
                document.querySelector('header').classList.add('bg-added');
            } else {
                document.querySelector('header').classList.remove('bg-added');
            }
        });
    }


    const landingContainer = document.querySelector('#landing');

    console.log('landingContainer', landingContainer);
    if (landingContainer) {
        landingContainer.addEventListener('scroll', () => {
            const scrollPosition = landingContainer.scrollTop;
            console.log('vvvvv Scroll position:', scrollPosition);
            if (scrollPosition > 1) {
                document.querySelector('header').classList.add('bg-added');
            } else {
                document.querySelector('header').classList.remove('bg-added');
            }
        });
    }

    // Append live events icons to description
    const icons_1 = document.createElement('img');
    const icons_2 = document.createElement('img');
    icons_1.src = "";
    icons_2.src = "";

    $('.live-events-landing-page .image-with-text__content .image-with-text__text em').empty();
    $('.live-events-landing-page section:nth-child(2) .image-with-text__content .image-with-text__text  em:nth-of-type(1)').append(icons_1);
    $('.live-events-landing-page section:nth-child(2) .image-with-text__content .image-with-text__text  em:last-of-type').append(icons_2);

    $('.live-events-landing-page section:nth-child(3) .image-with-text__content .image-with-text__text  em:nth-of-type(1)').append(icons_1);
    $('.live-events-landing-page section:nth-child(3) .image-with-text__content .image-with-text__text  em:nth-of-type(2)').append(icons_2);

    let selector1 = '.live-events-landing-page section:nth-child(2)  .image-with-text__content .image-with-text__text em'
    let selector2 = '.live-events-landing-page section:nth-child(3)  .image-with-text__content .image-with-text__text em'

    function appendIcons(selector, icon1, icon2) {
        $(selector).each(function (index) {
            var images = [
                `https://cdn.shopify.com/s/files/1/0595/8487/2585/files/events_icons${icon1}.png?v=1714360476`,
                `https://cdn.shopify.com/s/files/1/0595/8487/2585/files/events_icons${icon2}.png?v=1714360476`
            ];

            $(this).find('img').attr('src', images[index]);
        });
    }

    appendIcons(selector1, 1, 2)
    appendIcons(selector2, 3, 4)


})
